module.exports = {"500151001":"巴川街道","500151002":"东城街道","500151003":"南城街道","500151004":"蒲吕街道","500151005":"旧县街道","500151101":"土桥镇","500151103":"二坪镇","500151104":"水口镇","500151105":"安居镇","500151106":"白羊镇","500151107":"平滩镇","500151108":"小林镇","500151109":"双山镇","500151110":"虎峰镇","500151111":"石鱼镇","500151112":"福果镇","500151113":"庆隆镇","500151114":"少云镇","500151115":"维新镇","500151116":"高楼镇","500151117":"大庙镇","500151118":"围龙镇","500151119":"华兴镇","500151120":"永嘉镇","500151121":"安溪镇","500151122":"西河镇","500151123":"侣俸镇","500151124":"太平镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500151.json
// module id = 2055
// module chunks = 0